import { normalizeFilters } from "@/forms/helpers";
import { formatSelectOptions } from "@/forms/validation";
import { parseSearchParamsChainOrNull } from "@/lib/utils";

export function createFilterModel(
  source: {
    specialization: { [key: string]: string };
    province: { [key: string]: string };
  },
  searchParams: URLSearchParams,
) {
  const { specialization: specializationOptions, province: provinceOptions } =
    source;
  const specialization = searchParams.get("specialization");
  const province = searchParams.get("province");

  const fields: FiltersModel = {
    specialization: {
      // label: "Specjalizacja",
      type: "multiselect",
      placeholder: "Wybierz specjalizację",
      options: formatSelectOptions(specializationOptions),
      value: parseSearchParamsChainOrNull(specialization),
    },
    province: {
      // label: "Województwo",
      type: "multiselect",
      placeholder: "Wybierz województwo",
      options: formatSelectOptions(provinceOptions),
      value: parseSearchParamsChainOrNull(province),
    },
    q: {
      type: "text",
      placeholder: "Wyszukaj",
      value: searchParams.get("q") ?? "",
    },
  };

  return normalizeFilters(fields);
}
